import { ComponentType, FC } from "react";
import { ProtectedRoute } from "./ProtectedRoute";

export function withProtectedRoute<T extends object>(
  Component: ComponentType<T>,
): FC<T> {
  const C: FC<T> = (props) => {
    return (
      <ProtectedRoute>
        <Component {...props} />
      </ProtectedRoute>
    );
  };

  return C;
}
